export default class OkResponse extends Response {
  constructor() {
    super("OK", { status: 200 });
  }
};
